// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form{

}

.styles_container__dtQia{
  width: var(--container-width-md);
  max-width: 1920px;
  margin: 48px auto 0 auto ;
  display: flex;
  flex-direction: column;
}

.styles_container__dtQia > div {
  margin: auto;
}

.styles_container__dtQia > div > h4{
  font-style: normal;
  font-weight: 450;
  font-size: 24px;
  line-height: 34px;
  display: flex;
  align-items: center;
  text-align: center;
  margin: auto;
}

.styles_container__dtQia > div > h3{
  margin-top: 22px;
  margin-bottom: 27px;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  display: flex;
  align-items: center;
  text-align: center;
}

.styles_container__dtQia > fieldset{
  margin: auto;
  width: 343px;
}

.styles_container__dtQia > fieldset >label{
  font-style: normal;
  font-weight: 420;
  font-size: 14px;
  line-height: 20px;
}

.styles_container__dtQia > fieldset >input{
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  width: 343px;
  height: 48px;
  font-family: 'Brandon Grotesque';
  font-style: normal;
  font-weight: 390;
  font-size: 18px;
  line-height: 26px;
  padding: 12px;
  margin-bottom: 40px;
}

.styles_container__dtQia > fieldset >input:focus{
  border: 1px solid #B88F3E
  
}

.styles_container__dtQia > button{
  margin: 32px auto 20px auto;
  width: 342px;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 500;
  font-family: 'Brandon Grotesque';
  cursor: pointer;
  background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);
  color: var(--color-primary-white);
  cursor: pointer;
}

.styles_remember__kwCjm{
  width: 342px;
  height: 40px;
  display: flex;
  align-items: center;
  font-family: 'Brandon Grotesque';
  font-style: normal;
  font-weight: 420;
  font-size: 16px;
  line-height: 23px;
/* identical to box height */

display: flex;
align-items: center;
text-align: center;
}
.styles_remember__kwCjm > input{
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.styles_forgot__93\\+ME{
  width: 342px;
  font-family: 'Brandon Grotesque';
  font-style: normal;
  font-weight: 420;
  font-size: 18px;
  line-height: 26px;
  color: #B88F3E;
  margin: 17px auto 0 auto;
}

.styles_account__ced9F{
  margin: 27px auto 0px auto;
  font-family: 'Brandon Grotesque';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  color: #B88F3E;
}

.styles_terms__wNaBt{
  margin: 34px auto 57px auto;
  width: 336px;
  height: 46px;
  font-style: normal;
  font-weight: 390;
  font-size: 16px;
  line-height: 23px;
  text-align: center;
  padding: 4px;
}`, "",{"version":3,"sources":["webpack://./src/pages/AuthPage/styles.module.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;;AAEF;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,wFAAwF;EACxF,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB,4BAA4B;;AAE5B,aAAa;AACb,mBAAmB;AACnB,kBAAkB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd","sourcesContent":["form{\n\n}\n\n.container{\n  width: var(--container-width-md);\n  max-width: 1920px;\n  margin: 48px auto 0 auto ;\n  display: flex;\n  flex-direction: column;\n}\n\n.container > div {\n  margin: auto;\n}\n\n.container > div > h4{\n  font-style: normal;\n  font-weight: 450;\n  font-size: 24px;\n  line-height: 34px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin: auto;\n}\n\n.container > div > h3{\n  margin-top: 22px;\n  margin-bottom: 27px;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 34px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n}\n\n.container > fieldset{\n  margin: auto;\n  width: 343px;\n}\n\n.container > fieldset >label{\n  font-style: normal;\n  font-weight: 420;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.container > fieldset >input{\n  border: 1px solid #E0E0E0;\n  border-radius: 8px;\n  width: 343px;\n  height: 48px;\n  font-family: 'Brandon Grotesque';\n  font-style: normal;\n  font-weight: 390;\n  font-size: 18px;\n  line-height: 26px;\n  padding: 12px;\n  margin-bottom: 40px;\n}\n\n.container > fieldset >input:focus{\n  border: 1px solid #B88F3E\n  \n}\n\n.container > button{\n  margin: 32px auto 20px auto;\n  width: 342px;\n  height: 40px;\n  border-radius: 8px;\n  font-size: 18px;\n  font-weight: 500;\n  font-family: 'Brandon Grotesque';\n  cursor: pointer;\n  background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);\n  color: var(--color-primary-white);\n  cursor: pointer;\n}\n\n.remember{\n  width: 342px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  font-family: 'Brandon Grotesque';\n  font-style: normal;\n  font-weight: 420;\n  font-size: 16px;\n  line-height: 23px;\n/* identical to box height */\n\ndisplay: flex;\nalign-items: center;\ntext-align: center;\n}\n.remember > input{\n  width: 16px;\n  height: 16px;\n  margin-right: 10px;\n}\n\n.forgot{\n  width: 342px;\n  font-family: 'Brandon Grotesque';\n  font-style: normal;\n  font-weight: 420;\n  font-size: 18px;\n  line-height: 26px;\n  color: #B88F3E;\n  margin: 17px auto 0 auto;\n}\n\n.account{\n  margin: 27px auto 0px auto;\n  font-family: 'Brandon Grotesque';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 26px;\n  color: #B88F3E;\n}\n\n.terms{\n  margin: 34px auto 57px auto;\n  width: 336px;\n  height: 46px;\n  font-style: normal;\n  font-weight: 390;\n  font-size: 16px;\n  line-height: 23px;\n  text-align: center;\n  padding: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__dtQia`,
	"remember": `styles_remember__kwCjm`,
	"forgot": `styles_forgot__93+ME`,
	"account": `styles_account__ced9F`,
	"terms": `styles_terms__wNaBt`
};
export default ___CSS_LOADER_EXPORT___;
